import Validator from '@surveyplanet/validator';
import {
	getLoggedInUser,
	getQueryStringParams,
	addAlert,
	removeAlert,
} from './utilities';

class Contact {
	constructor() {
		this.nameInput = document.getElementById('name');
		this.emailInput = document.getElementById('email');
		this.subjectInput = document.getElementById('subject');
		this.messageInput = document.getElementById('message');
		this.submitButton = document.getElementById('contact-submit-button');

		this.validator = null;

		this.message = getQueryStringParams('msg');
		this.subject = getQueryStringParams('sub');

		this.initForm();
	}

	static get SUPPORT_URL() {
		return `${GLOBALS.uris.api}/v1/support`;
	}

	initForm() {
		if (this.subject && this.subject.length) {
			this.subjectInput.value = this.subject;
		}

		if (this.message && this.message.length) {
			this.messageInput.value = this.message;
			this.messageInput.focus();
		}

		if (
			(this.message && this.message.length) ||
			(this.subject && this.subject.length)
		) {
			this.scrollToForm();
		}

		getLoggedInUser().then((data) => {
			if (!data || !data.user) {
				return;
			}

			if (data.user.email) {
				this.emailInput.value = data.user.email;
			}

			if (data.user.name) {
				let name = '';

				if (data.user.name.first) {
					name = data.user.name.first;
				}

				if (data.user.name.last) {
					if (name.length) {
						name += ' ';
					}
					name += data.user.name.last;
				}

				if (name.length) {
					this.nameInput.value = name;
				}
			}
		});

		this.validator = new Validator([
			{
				name: 'name',
				label: 'Name',
				rules: 'minLength[2]',
			},
			{
				name: 'email',
				label: 'Email',
				rules: ['required', 'email'],
			},
			{
				name: 'message',
				label: 'Message',
				rules: ['required', 'minLength[8]'],
			},
		]);

		this.validator.showValidationErrors = true;

		this.submitButton.addEventListener(
			'click',
			this.submitButtonHandler.bind(this)
		);
	}

	clearForm() {
		setTimeout(removeAlert, 8000);

		this.nameInput.value = '';
		this.emailInput.value = '';
		this.subjectInput.value = '';
		this.messageInput.value = '';
	}

	scrollToForm() {
		setTimeout(() => {
			this.subjectInput.scrollIntoView();
		}, 100);
	}

	async submitForm(e) {
		const validationErrors = this.validator.validate();

		// show errors instead of submitting
		if (validationErrors && validationErrors.length) {
			return null;
		}

		this.submitButton.disabled = true;
		const data = {
			name: this.nameInput.value,
			email: this.emailInput.value,
			subject: this.subjectInput.value,
			message: this.messageInput.value,
		};

		const res = await fetch(Contact.SUPPORT_URL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});

		const resJson = await res.json();

		this.submitButton.disabled = false;

		if (!res.ok) {
			return addAlert(
				'Sorry, there was a problem submitting your request. Please contact us directly at <a href="mailto:support@surveyplanet.com">support@surveyplanet.com</a>.',
				'error'
			);
		}

		addAlert(
			'Thanks for contacting us, we\'ll be in touch very soon. In the mean time, please consider taking this short <a href="https://s.surveyplanet.com/55c898e7faa137f42409d403">Feedback Survey</a>.'
		);
		this.clearForm();
	}

	submitButtonHandler(e) {
		e.preventDefault();
		this.submitForm();
	}
}

export default new Contact();
